<div class="ml-20px">
  <gh-indicator [ghValue]="indicators.loadingIndicator" (onReset)="resetIndicator('loadingIndicator')" ghMessage="{{ 'loading' | localize }}"></gh-indicator>
</div>
<div *ngIf="!indicators.loadingIndicator" class="p-8px" id="account-notification-layout">
  <div id="account-title-container">
    <h2>
      {{ "account_notification_settings" | localize }}
    </h2>
    <p class="mt-4px">{{ "account_notification_pref_descr" | localize }}</p>
  </div>

  <div class="mt-16px">
    <gh-notification-layout class="mt-16px" [notificationSettings]="notificationSettings" [notificationClass]="'account'"></gh-notification-layout>
  </div>

  <div class="form-actions mt-24px">
    <button gh-button type="submit" size="large" kind="primary" data-button="Save" (click)="saveAccountNotification()">
      {{ "confirm" | localize }}
    </button>
    <button gh-button size="large" kind="secondary" (click)="cancel()">
      {{ "cancel" | localize }}
    </button>
    <gh-indicator [ghValue]="indicators.patchIndicator" (onReset)="resetIndicator('patchIndicator')" ghMessage="{{ 'loading' | localize }}"></gh-indicator>
  </div>
</div>
